import handler from '../handler/handler';
import messages from '../handler/messages/messages';

const responseHandler = handler(messages);

export default {
  actions: {
    createEmptyAddress: async ({ commit, getters }) => {
      const result = await responseHandler.authPost({ commit, getters }, '/api/addresses');
      return result;
    },

    updateAddress: async ({ commit, getters }, data) => {
      const address = {
        id: data.id,
        name: data.name,
        warehouseId: data.warehouseId,
        deliveryDelayHours: data.deliveryDelayHours,
        address: data.address,
        country: data.country,
        city: data.city,
        administrative: data.administrative,
        locality: data.locality,
        street: data.street,
        localityDetail: data.localityDetail,
        streetDetail: data.streetDetail,
        latitude: data.latitude,
        longitude: data.longitude,
        type: data.type,
        bizlocCode: data.bizlocCode,
        addressOvr: data.addressOvr,
        idDeleted: data.isDeleted,
        howToGo: data.howToGo,
        imgPlace: data.imgPlace,
        isEnabled: data.isEnabled,
      };

      const result = await responseHandler.authPut({ commit, getters }, `/api/addresses/${address.id}`, address);
      return result;
    },

    deleteAddress: async ({ commit, getters }, id) => {
      const result = await responseHandler.authDelete({ commit, getters }, `/api/addresses/${id}`);
      return result;
    },

    deleteAddresses: async ({ commit, getters }, ids) => {
      const result = await responseHandler.authPatch({ commit, getters }, '/api/addresses/delete', ids);
      return result;
    },
  },
};



// WEBPACK FOOTER //
// ./src/vuex/modules/address.js